module.exports = __webpack_public_path__ + "img/report-finance-imange.6135f996.svg";